<template>
  <div @click="changeImg" class="mask-img" :style="[maskUrl]"></div>
</template>

<script>
export default {
  name: 'Mheader',
  data() {
    return {
      max: 51,
      r: 0,
      maskUrl: {}
    }
  },
  methods: {
    changeImg() {
      let rImg = (() => {
        this.r = Math.ceil(Math.random() * this.max).toString();
        return new Array(4 - this.r.length).join('0') + this.r;
      })();
      let url = 'https://aliyunoss.mldie.com/mldieblog/' + rImg + '.jpg';
      // let img = new Image();
      // img.src = url;
      // img.onload = () => {
        this.maskUrl = {
          backgroundImage: 'url(' + url + ')',
        }
      // }
    }
  }
}
</script>

<style scoped>
.mask-img {
  transition: all .8s;
  cursor: pointer;
  max-width: 630px;
  height: 150px;
  background: #333 no-repeat center;
  /*background-color: #efefef;*/
  /*background-image: url(../../static/images/001.jpg);*/
  background-repeat:no-repeat;
  background-position:center; 
  background-size: 100% auto;
  mask-image: url(../../static/images/mldie.png);
  mask-repeat:no-repeat;
  mask-position:center; 
  mask-size: 100% auto;
}
</style>

